exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../containers/Popovers/Popovers.css"), undefined);

// module
exports.push([module.id, "._2mZWsOsl-Y4ZaA1x5C1LNH {\n  min-width: 240px;\n  padding: 11px 16px;\n}\n", ""]);

// exports
exports.locals = {
	"popover": "" + require("-!../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../containers/Popovers/Popovers.css").locals["popover"] + "",
	"dropdownSearchPopover": "_2mZWsOsl-Y4ZaA1x5C1LNH " + require("-!../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"modules\":{\"localIdentName\":\"[name]__[local]___[hash:base64:5]\"}}!../../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../containers/Popovers/Popovers.css").locals["popover"] + ""
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/containers/Popovers/DropdownSearchPopover/DropdownSearchPopover.css
// module id = 3194
// module chunks = 23